import classNames from 'classnames';
import { useSelector } from 'react-redux';

import settings from '/@/core/settings';
import { useCornTechnologies } from '/@/hooks/catalog';
import { _ } from '/@/locale';
import { getSelectedTechnology } from '/@/store/catalog/selectors';
import { isMobile } from '/@/utils';
// V3 Components
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

const TechnologyList = ({
    type,
    brand,
    technologies,
    title,
    size,
    showCatalogLink,

    displayTechnologyName,
    setTechnology: setTechnologyFromProps,
}) => {
    const cornTechnologiesQuery = useCornTechnologies({ page: 1, pageSize: 10000 });
    const selectedTechnology = useSelector((state) =>
        getSelectedTechnology(
            state,
            (cornTechnologiesQuery.data?.results || []).filter((t) => t.displayInCatalog)
        )
    );

    const renderTechnology = ({ id, name, logoImage, images }) => {
        const image = images.find((i) => i.brand === brand.id)?.image;

        const selected = selectedTechnology ? id === selectedTechnology.id : false;
        return (
            <div
                key={id}
                onClick={() => setTechnology(id)}
                className={classNames(selected ? styles.selectedTechnology : '')}
            >
                <div className={styles.technologiesList}>
                    {image && (
                        <div>
                            <div className={classNames(styles.image)} style={{ backgroundImage: `url('${image}')` }} />
                        </div>
                    )}
                </div>
                {displayTechnologyName && !isMobile() ? (
                    displayTechnologyName(selected, logoImage)
                ) : (
                    <div className={styles.name}>{_(name)}</div>
                )}
            </div>
        );
    };

    const setTechnology = (id) => {
        if (setTechnologyFromProps) setTechnologyFromProps(id);
    };

    return (
        <div className={classNames(styles.root, styles[`size-${size}`])}>
            {title && (
                <div className={styles.title}>
                    <Title size='xl' color='primary' bolder>
                        {_(title)}
                    </Title>
                </div>
            )}
            <div
                className={classNames(
                    styles.technologies,
                    styles[`theme-${settings.app.theme === 'expertobayer' ? settings.app.theme : brand.theme}`]
                )}
            >
                <div className={styles.container}>
                    <div className={styles.technology}>{technologies.map(renderTechnology)}</div>
                </div>
            </div>
        </div>
    );
};

export default TechnologyList;
